import { configureStore } from "@reduxjs/toolkit";
import menuSlice from "./menuSlice";
import modalSlice from "./modalSlice";
import { blogApi } from "./services/blogServices";
import { userApi } from "./services/userServices";
import authSlice from "./authSlice";
import alertSlice from "./alertSlice";
import userSlice from "./userSlice";
import selectedReceiptsSlice from "./selectedReceiptsSlice";
import createItemModalSlice from "./createItemModalSlice";
import editItemModalSlice from "./editItemModalSlice";
import { locationsTypeApi } from "./services/locationsServices";
import { receiptsApi } from "./services/receiptsServices";
import receiptViewSlice from "./receiptViewSlice";
import { notificationApi } from "./services/notificationServices";
import approvedReceiptViewSlice from "./approvedReceiptViewSlice";
import { homepageApi } from "./services/homepageServices";
import { auditLogApi } from "./services/auditLogServices";
import { bankApi } from "./services/bankServices";
import auditLogViewSlice from "./auditLogViewSlice";
import nonFiscalReceiptViewSlice from "./nonFiscalReceiptViewSlice";
import { reportsApi } from "./services/reportsServices";
import { complaintsApi } from "./services/complaintsServices";
import complainReplySlice from "./complainReplySlice";
import complaintViewSlice from "./complaintViewSlice";
import { gameApi } from "./services/gameServices";
import { prizeApi } from "./services/prizeServices";
import notificationViewSlice from "./services/notificationViewSlice";
import { nacApi } from "./services/nacServices";
import { municipalitiesApi } from "./services/municipalitiesServices";
import gameDetailsSlice from "./gameDetailsSlice";
import { notificationTemplatesApi } from "./services/notificationTemplatesServices";
import { rolesApi } from "./services/rolesServices";
import { businessApi } from "./services/businessServices";
import { businessWinnerApi } from "./services/businessWinnersServices";
import gamesFiltersModalSlice from "./gamesFiltersModalSlice";
import gameCancelModalSlice from "./gameCancelModal";
import notificationsFiltersModalSlice from "./notificationsFiltersModalSlice";
import userDetailsSlice from "./userDetailsSlice";
import exportXLSModalSlice from "./exportXLSModalSlice";
import winnerDetailsSlice from "./winnerDetailsSlice";
import businessWinnerDetailsSlice from "./businessWinnerDetailsSlice";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    menu: menuSlice.reducer,
    modal: modalSlice.reducer,
    create_item_modal: createItemModalSlice.reducer,
    edit_item_modal: editItemModalSlice.reducer,
    auth: authSlice.reducer,
    alert: alertSlice.reducer,
    selectedReceipts: selectedReceiptsSlice.reducer,
    receipt_view: receiptViewSlice.reducer,
    approved_receipt_view: approvedReceiptViewSlice.reducer,
    nonfiscal_receipt_view: nonFiscalReceiptViewSlice.reducer,
    audit_log_view: auditLogViewSlice.reducer,
    complain_reply: complainReplySlice.reducer,
    complaint_view: complaintViewSlice.reducer,
    notification_view: notificationViewSlice.reducer,
    game_details: gameDetailsSlice.reducer,
    game_filters_modal: gamesFiltersModalSlice.reducer,
    game_cancel_modal: gameCancelModalSlice.reducer,
    user_details: userDetailsSlice.reducer,
    notifications_filters_modal: notificationsFiltersModalSlice.reducer,
    export_xls_modal: exportXLSModalSlice.reducer,
    winner_details: winnerDetailsSlice.reducer,
    business_winner_details: businessWinnerDetailsSlice.reducer,
    [receiptsApi.reducerPath]: receiptsApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [locationsTypeApi.reducerPath]: locationsTypeApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [homepageApi.reducerPath]: homepageApi.reducer,
    [auditLogApi.reducerPath]: auditLogApi.reducer,
    [bankApi.reducerPath]: bankApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [complaintsApi.reducerPath]: complaintsApi.reducer,
    [gameApi.reducerPath]: gameApi.reducer,
    [prizeApi.reducerPath]: prizeApi.reducer,
    [nacApi.reducerPath]: nacApi.reducer,
    [municipalitiesApi.reducerPath]: municipalitiesApi.reducer,
    [notificationTemplatesApi.reducerPath]: notificationTemplatesApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [businessApi.reducerPath]: businessApi.reducer,
    [businessWinnerApi.reducerPath]: businessWinnerApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      receiptsApi.middleware,
      blogApi.middleware,
      userApi.middleware,
      locationsTypeApi.middleware,
      notificationApi.middleware,
      homepageApi.middleware,
      auditLogApi.middleware,
      bankApi.middleware,
      reportsApi.middleware,
      complaintsApi.middleware,
      gameApi.middleware,
      prizeApi.middleware,
      nacApi.middleware,
      municipalitiesApi.middleware,
      notificationTemplatesApi.middleware,
      rolesApi.middleware,
      businessApi.middleware,
      businessWinnerApi.middleware
    ),
});

export default store;
